<template>
  <div class="dm-body">
    <template v-if="!sel_user.loggedIn">
      <div v-if="showLogin">
        <Login />
          <!-- <p>Non ancora registrato? <span @click="showLogin = false" class="linkable">REGISTRATI</span></p> -->
          <!-- <p>Password dimenticata? <span @click="resetPwd" class="linkable">RESET Password</span></p> -->
      </div>
      <!-- <div v-else>
        <Signup />
          <p>Gia registrato? <span @click="showLogin = true" class="linkable">ACCEDI</span></p>
      </div> -->
    </template>
    <!-- <template v-else>
      <UserProfile />
    </template> -->
  </div>
</template>

<script>
  import Login from '../components/Login.vue'
  //import Signup from '../components/Signup.vue'
  //import Dashboard from './Dashboard.vue'
  //import UserProfile from '../components/users/UserProfile.vue'
  import { mapGetters } from 'vuex'


  export default {
    data() {
      return {
          showLogin: true
      }
    },
    computed: {
      ...mapGetters({
          // map `this.user` to `this.$store.getters.user`
          auth_user: "user",
          sel_user: "_user",
      })
    },
    components: {
      //Signup,
      Login,
      /*//Dashboard,
      UserProfile*/
    },
    methods: {
      /*resetPwd() {
        alert('Funzione da rilasciare a breve ...')
        return 
      }*/
    }
  };
</script>

<style>
.dm-body {
  text-align: center;
  padding: 20px 0;
}
.linkable {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>